import { render, staticRenderFns } from "./ClubhouseDialog.vue?vue&type=template&id=8b3bb982&scoped=true"
import script from "./ClubhouseDialog.vue?vue&type=script&lang=js"
export * from "./ClubhouseDialog.vue?vue&type=script&lang=js"
import style0 from "./ClubhouseDialog.vue?vue&type=style&index=0&id=8b3bb982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3bb982",
  null
  
)

export default component.exports